module.exports = __webpack_public_path__ + "static/media/my_book_blog_mobile.f8c76854.PNG";